import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { 
  Database, 
  Activity, 
  Settings,
  BarChart3,
  Archive
} from 'lucide-react';
import { DatabaseStatsCard, BackupManagementCard } from './DatabaseManagement';
import BackupProgressMonitor from './BackupProgressMonitor';

const DatabaseDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="container mx-auto py-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Gestión de Base de Datos</h1>
        <p className="text-muted-foreground">
          Monitorea el estado de la base de datos, administra backups y configura políticas de retención.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="overview" className="flex items-center gap-2">
            <Database className="h-4 w-4" />
            Resumen
          </TabsTrigger>
          <TabsTrigger value="progress" className="flex items-center gap-2">
            <Activity className="h-4 w-4" />
            Progreso de Backups
          </TabsTrigger>
          <TabsTrigger value="backups" className="flex items-center gap-2">
            <Archive className="h-4 w-4" />
            Gestión de Backups
          </TabsTrigger>
          <TabsTrigger value="stats" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            Estadísticas
          </TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="space-y-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <DatabaseStatsCard />
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Activity className="h-5 w-5" />
                  Estado del Sistema
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium">Base de Datos</span>
                    <span className="text-sm text-green-600">Conectada</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium">Backups Programados</span>
                    <span className="text-sm text-blue-600">Activos</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium">Última Verificación</span>
                    <span className="text-sm text-muted-foreground">
                      {new Date().toLocaleTimeString()}
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </TabsContent>

        <TabsContent value="progress" className="space-y-6">
          <BackupProgressMonitor />
        </TabsContent>

        <TabsContent value="backups" className="space-y-6">
          <BackupManagementCard />
        </TabsContent>

        <TabsContent value="stats" className="space-y-6">
          <DatabaseStatsCard />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default DatabaseDashboard;